/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Brouillon
 * 1 = Envoye
 */
export enum StatutRapportPrepose {
  Brouillon = 0,
  Envoye = 1
}
